import gql from "graphql-tag";

export const CLEAR_CACHE_REQUEST = gql`
  query {
    clearCache {
      statusCode
      message
      data
    }
  }
`;